import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { AppStateService } from '@shared/services/app-state.service';
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { Adjust, AdjustEvent } from '@awesome-cordova-plugins/adjust';
import { FacebookEvents } from 'capacitor-facebook-events';
import { getApps, initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { environment } from 'src/environments/environment';
import { FirebaseAnalyticsService } from '@shared/services/firebase-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  public userData: any;
  private lastStoreFromTypeEvent: string = '';
  private analytics: any;
  private adjustInitialized: boolean = false;

  constructor(
    private appStateService: AppStateService,
    private firebaseAnalyticsService: FirebaseAnalyticsService
  ) {
    if (!Capacitor.isNativePlatform()) {
      this.initializeFirebaseOnlyWeb();
    } else {
      FirebaseAnalytics.setCollectionEnabled({ enabled: environment.production })
    }
  }

  private initializeAdjust() {
    if (!this.adjustInitialized && Capacitor.isNativePlatform() && this.appStateService.adjustConfig) {
      try {
        Adjust.initSdk(this.appStateService.adjustConfig);
        this.adjustInitialized = true;
        console.log('Adjust SDK initialized successfully');
      } catch (error) {
        console.error('Error initializing Adjust SDK:', error);
      }
    }
  }


  public initializeFirebaseOnlyWeb() {
    /**
 * Platform: Web
 * Configure and initialize the firebase app.
 * @param options - firebase web app configuration options
 * */
    if (!getApps().length) {
      const firebaseConfig = {
        apiKey: "AIzaSyAtgYtgAuKGflP79cWo0__j--53ihQTQmY",
        authDomain: "lefty-4f864.firebaseapp.com",
        projectId: "lefty-4f864",
        storageBucket: "lefty-4f864.firebasestorage.app",
        messagingSenderId: "888967854315",
        appId: "1:888967854315:web:f42bc98e191c143186e6ae",
        measurementId: "G-RZ8KS9SLBK"
      };

      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      this.analytics = getAnalytics(app);
      this.firebaseAnalyticsService.setAnalyticsInstance(this.analytics);
    }
  }

  public static signUpEvent: any = {
    eventName: 'sign_up',
    adjustEvent: '9xtn5w'
  };

  public static likeEvent: any = {
    eventName: 'like',
    adjustEvent: '4vos17'
  }

  public static matchEvent: any = {
    eventName: 'match',
    adjustEvent: 'f6fd9d'
  }

  public static superLikeEvent: any = {
    eventName: 'super_like',
    adjustEvent: 'e867aq'
  }

  public static sendMessageEvent: any = {
    eventName: 'send_message',
    adjustEvent: 'aawh2l'
  }

  public static market: any = {
    eventName: 'market',
    adjustEvent: 'ulqt9o'
  }

  public static mktFromMenu: any = {
    eventName: 'mkt_from_menu',
    adjustEvent: 'ltr8mk'
  }

  // Avocado Store Events

  public static avocado: any = {
    eventName: 'avocado',
    adjustEvent: 'smmmvl'
  }

  public static avcdFromMkt: any = {
    eventName: 'avcd_from_mkt',
    adjustEvent: 'id0oyy'
  }

  public static avcdFromLikedme: any = {
    eventName: 'avcd_from_likedme',
    adjustEvent: 'd3uy20'
  }

  public static avcdFromTeleport: any = {
    eventName: 'avcd_from_teleport',
    adjustEvent: 'uvxp9d'
  }

  public static avcdFromIndicator: any = {
    eventName: 'avcd_from_indicator',
    adjustEvent: 'iogck5'
  }

  public static avcdFromIndicatorExpl: any = {
    eventName: 'avcd_from_indicator_expl',
    adjustEvent: 'st1o85'
  }

  public static avcdFromFirstOpen: any = {
    eventName: 'avcd_from_first_open',
    adjustEvent: 'p4t5cd'
  }

  public static avcdFromFirstPhoto: any = {
    eventName: 'avcd_from_first_photo',
    adjustEvent: 'i0xlj0'
  }

  public static avcdFromReadConf: any = {
    eventName: 'avcd_from_read_conf',
    adjustEvent: 'u03287'
  }

  public static avcdCheckoutSuccess: any = {
    eventName: 'avcd_checkout_success',
    adjustEvent: '2g1dkd'
  }

  public static avcdCheckoutSuccessFromMkt: any = {
    eventName: 'avcd_checkout_success_from_mkt',
    adjustEvent: 'whxv94'
  }

  public static avcdCheckoutSuccessFromLikedMe: any = {
    eventName: 'avcd_checkout_success_from_likedme',
    adjustEvent: 'glafl4'
  }

  public static avcdCheckoutSuccessFromTeleport: any = {
    eventName: 'avcd_checkout_success_from_teleport',
    adjustEvent: 'hx0g1j'
  }

  public static avcdCheckoutSuccessFromIndicator: any = {
    eventName: 'avcd_checkout_success_from_indicator',
    adjustEvent: 'jv5llf'
  }

  public static avcdCheckoutSuccessFromIndicatorExpl: any = {
    eventName: 'avcd_checkout_success_from_indicator_expl',
    adjustEvent: 'ssms6g'
  }

  public static avcdCheckoutSuccessFromFirstOpen: any = {
    eventName: 'avcd_checkout_success_from_first_open',
    adjustEvent: '2fvxux'
  }

  public static avcdCheckoutSuccessFromFirstPhoto: any = {
    eventName: 'avcd_checkout_success_from_first_photo',
    adjustEvent: 'inut0a'
  }

  public static avcdCheckoutSuccessFromReadConf: any = {
    eventName: 'avcd_checkout_success_from_read_conf',
    AdjustEvent: 'phrj15'
  }

  // Carrots Store Events

  public static carrots: any = {
    eventName: 'carrots',
    adjustEvent: 'k822z6'
  }

  public static crrtFromMkt: any = {
    eventName: 'crrt_from_mkt',
    adjustEvent: 'o1xhz1'
  }

  public static crrtFromSuperlike: any = {
    eventName: 'crrt_from_superlike',
    adjustEvent: 'r8c1jy'
  }

  public static crrtFromBoost: any = {
    eventName: 'crrt_from_boost',
    adjustEvent: 'q4mg3o'
  }

  public static crrtCheckoutSuccess: any = {
    eventName: 'crrt_checkout_success',
    adjustEvent: 'd6myir'
  }

  public static crrtCheckoutSuccessFromMkt: any = {
    eventName: 'crrt_checkout_success_from_mkt',
    adjustEvent: 'luta2b'
  }

  public static crrtCheckoutSuccessFromSuperlike: any = {
    eventName: 'crrt_checkout_success_from_superlike',
    adjustEvent: 'c4ml5i'
  }

  public static crrtCheckoutSuccessFromBoost: any = {
    eventName: 'crrt_checkout_success_from_boost',
    adjustEvent: '18d1qf'
  }

  public static checkoutStart: any = {
    eventName: 'checkout_start',
    adjustEvent: 'kn2cmv'
  }

  public static checkoutAbandoned: any = {
    eventName: 'checkout_abandoned',
    adjustEvent: 'cv8jer'
  }

  public static checkoutPayFail: any = {
    eventName: 'checkout_pay_fail',
    adjustEvent: 'uqjyry'
  }

  // Unique events

  public static loginOrSignUpCompl: any = {
    eventName: 'login_or_sign_up_compl',
    adjustEvent: '6n04hg'
  }

  public static loginOrSignUpComplVegan: any = {
    eventName: 'login_or_sign_up_compl_vegan',
    adjustEvent: 'kr4r48'
  }

  public static loginOrSignUpComplVegetarian: any = {
    eventName: 'login_or_sign_up_compl_vegetarian',
    adjustEvent: 'pqagya'
  }

  public static loginOrSignUpComplInTransition: any = {
    eventName: 'login_or_sign_up_compl_intransition',
    adjustEvent: 'sir3l0'
  }

  public static loginOrSignUpComplOk: any = {
    eventName: 'login_or_sign_up_compl_ok',
    adjustEvent: 'c2w1aa'
  }

  public static loginOrSignUpComplOkVegan: any = {
    eventName: 'login_or_sign_up_compl_ok_vegan',
    adjustEvent: '4hirhp'
  }

  public static loginOrSignUpComplOkVegetarian: any = {
    eventName: 'login_or_sign_up_compl_ok_vegetarian',
    adjustEvent: 'j42of0'
  }

  public static loginOrSignUpComplOkInTransition: any = {
    eventName: 'login_or_sign_up_compl_ok_intransition',
    adjustEvent: 'fhz9n9'
  }

  public static loginOrSignUpValuable: any = {
    eventName: 'login_or_sign_up_valuable',
    adjustEvent: '7kutar'
  }

  public static loginOrSignUpValuableVegan: any = {
    eventName: 'login_or_sign_up_valuable_vegan',
    adjustEvent: '1xzl6g'
  }

  public static loginOrSignUpValuableVegetarian: any = {
    eventName: 'login_or_sign_up_valuable_vegetarian',
    adjustEvent: 'hq3t4y'
  }

  public static loginOrSignUpValuableInTransition: any = {
    eventName: 'login_or_sign_up_valuable_intransition',
    adjustEvent: '7b5i4p'
  }

  public static signUpComplete: any = {
    eventName: 'sign_up_complete',
    adjustEvent: 'af4w5d'
  }

  public static signUpComplOk: any = {
    eventName: 'sign_up_compl_ok',
    adjustEvent: 'h1girl'
  }

  public static excludedFail: any = {
    eventName: 'excluded_fail',
    adjustEvent: 'b0x079'
  }

  public static valuableUser: any = {
    eventName: 'valuable_user',
    adjustEvent: 'yd2elc'
  }


  registerEvent(eventDetails: any, isUnique?: boolean) {
    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      this.userData = val.value ? JSON.parse(val.value) : null;
      if (this.userData && this.userData.excluded_fail && eventDetails?.eventName != 'excluded_fail')
        return;
      if (isUnique) {
        let diet = (this.userData &&
          this.userData.diet !== null &&
          this.userData.diet !== undefined) ? this.userData.diet : '';
        this.registerUniqueEvent(eventDetails, diet);
      } else {
        this.sendEventToAnalytics(eventDetails, false);
        if (eventDetails?.eventName.includes('from'))
          this.lastStoreFromTypeEvent = eventDetails?.eventName;
        if (eventDetails?.eventName.includes('checkout'))
          this.registerRelatedCheckoutFromEvent(eventDetails?.eventName);
      }
    })
  }

  registerUniqueEvent(eventDetails: any, diet: string) {

    console.log('registerUniqueEvent');
    console.log(JSON.stringify(eventDetails));
    console.log(diet);
    if (eventDetails?.eventName) {
      Preferences.get({ key: eventDetails?.eventName }).then((alreadyRegistered: any) => {
        alreadyRegistered = alreadyRegistered.value ? JSON.parse(alreadyRegistered.value) : null;

        if (alreadyRegistered) {
          return;
        }

        this.sendEventToAnalytics(eventDetails, true);
        if (diet !== '' && eventDetails?.eventName.includes('login_or_sign_up')) {
          this.registerRelatedDietEvent(eventDetails?.eventName, diet)
        }
      })
    }



  }

  registerRelatedCheckoutFromEvent(mainEvent: string) {
    /* lastStoreFromTypeEvent will be empty when purchase events arrive
    * at app startup. In this case we won't know from which screen user 
    * came from, so we don't send the related events.
    */
    if (this.lastStoreFromTypeEvent == '') {
      console.log('lastStoreFromTypeEvent is empty');
      return;
    }
    let checkoutSuccessFromEvents: any = {
      'crrt_from_mkt': AnalyticsService.crrtCheckoutSuccessFromMkt,
      'crrt_from_superlike': AnalyticsService.crrtCheckoutSuccessFromSuperlike,
      'crrt_from_boost': AnalyticsService.crrtCheckoutSuccessFromBoost,
      'avcd_from_mkt': AnalyticsService.avcdCheckoutSuccessFromMkt,
      'avcd_from_likedme': AnalyticsService.avcdCheckoutSuccessFromLikedMe,
      'avcd_from_teleport': AnalyticsService.avcdCheckoutSuccessFromTeleport,
      'avcd_from_indicator': AnalyticsService.avcdCheckoutSuccessFromIndicator,
      'avcd_from_indicator_expl': AnalyticsService.avcdCheckoutSuccessFromIndicatorExpl,
      'avcd_from_first_open': AnalyticsService.avcdCheckoutSuccessFromFirstOpen,
      'avcd_from_first_photo': AnalyticsService.avcdCheckoutSuccessFromFirstPhoto,
      'avcd_from_read_conf': AnalyticsService.avcdCheckoutSuccessFromReadConf
    }

    let checkoutState = mainEvent.split("_").slice(-2).join("_");
    switch (checkoutState) {
      case 'checkout_success':
        this.sendEventToAnalytics(checkoutSuccessFromEvents[this.lastStoreFromTypeEvent], false);
        break;
    }
  }

  registerRelatedDietEvent(mainEvent: string, diet: string) {
    let complDietEvents: any = {
      'vegan': AnalyticsService.loginOrSignUpComplVegan,
      'vegetarian': AnalyticsService.loginOrSignUpComplVegetarian,
      'working': AnalyticsService.loginOrSignUpComplInTransition
    };
    let complOkDietEvents: any = {
      'vegan': AnalyticsService.loginOrSignUpComplOkVegan,
      'vegetarian': AnalyticsService.loginOrSignUpComplOkVegetarian,
      'working': AnalyticsService.loginOrSignUpComplOkInTransition
    };
    let valuableDietEvents: any = {
      'vegan': AnalyticsService.loginOrSignUpValuableVegan,
      'vegetarian': AnalyticsService.loginOrSignUpValuableVegetarian,
      'working': AnalyticsService.loginOrSignUpValuableInTransition
    };

    switch (mainEvent) {
      case 'login_or_sign_up_compl':
        this.registerUniqueEvent(complDietEvents[diet], '');
        break;
      case 'login_or_sign_up_compl_ok':
        this.registerUniqueEvent(complOkDietEvents[diet], '');
        break;
      case 'login_or_sign_up_valuable':
        this.registerUniqueEvent(valuableDietEvents[diet], '');
    }
  }

  sendEventToAnalytics(eventDetails: any, isUnique?: boolean) {
    try {
      // Only run Adjust on native platforms
      if (Capacitor.isNativePlatform()) {
        // Inicializar Adjust apenas uma vez
        this.initializeAdjust();
        
        if (this.adjustInitialized && eventDetails?.adjustEvent) {
          var adjustEvent = new AdjustEvent(eventDetails.adjustEvent);
          Adjust.trackEvent(adjustEvent);
          console.log('Adjust event sent:', eventDetails.adjustEvent);
        } else {
          console.warn('Adjust not initialized or no adjustEvent provided:', eventDetails);
        }
      }

      // Firebase Analytics works on both platforms
      this.firebaseAnalyticsService.setAnalyticsEvent(eventDetails?.eventName, {});

      // Facebook Events (optional, can be skipped on web if not needed)
      if (Capacitor.isNativePlatform()) {
        FacebookEvents.logEvent({
          event: eventDetails?.eventName,
          params: {}
        });
      }

      console.log('"' + eventDetails?.eventName + '" event sent on provider.');
      if (isUnique) {
        Preferences.set({ key: eventDetails?.eventName, value: 'true' }).then(() => {
          console.log(eventDetails?.eventName + ' event saved to DB.');
        })
      }
    } catch (error) {
      // ignore reporting errors   
      console.log('Error registering a ' + eventDetails?.eventName);
      console.error(error);
    }
  }

  public setAnalyticsEvent(eventName: string, eventProperties: any) {
    if (Capacitor.isNativePlatform()) {
      FirebaseAnalytics.logEvent({
        name: eventName,
        params: eventProperties
      });
    } else {
      // Web platform - use native Firebase Analytics
      if (this.analytics) {
        logEvent(this.analytics, eventName, eventProperties);
      }
    }
  }

  /**
   * Método para testar se o Adjust está funcionando corretamente
   * Chame este método para verificar se os eventos estão sendo enviados
   */
  public testAdjustEvent() {
    console.log('🧪 Testando evento do Adjust...');
    
    const testEvent = {
      eventName: 'test_adjust_event',
      adjustEvent: 'test123' // Token de teste do Adjust
    };
    
    this.sendEventToAnalytics(testEvent);
    
    console.log('✅ Teste do Adjust concluído. Verifique os logs do Adjust SDK.');
  }

}
